import App from '../app.vue';
// 不作为Main组件的子页面展示的页面单独写，如下
import i18n from '@/util/lang'

export const pageError = {
    path: '*',
    name: '404',
    meta: {
        title: '404-页面不存在'
    },
    component: () =>
        import ('@/views/error/404.vue')
};

export const trainKeep = {
    path: '/class',
    name: 'Home',
    component: () =>
        import ('@/views/train/index.vue'),
    meta: {
        title: i18n.t('小奥课堂')
    }
}
export const packageKeep = {
    path: '/expansionPackage',
    name: 'expansionPackage',
    meta: { title: i18n.t('拓工包') },
    component: () =>
        import ('@/views/train/study/expansionPackage/index.vue'),
}
export const packageDetailKeep = {
    path: '/expansionPackageDetail',
    name: 'expansionPackageDetail',
    meta: { title: i18n.t('拓工包') },
    component: () =>
        import ('@/views/train/study/expansionPackageDetail/index.vue'),
}

export const questionKeep = {
    path: '/question',
    name: 'Question',
    component: App,
    children: [{
        path: '/',
        name: 'topic',
        meta: { title: i18n.t('题库') },
        component: () =>
            import ('@/views/train/question/topic/index.vue')
    }]

}

export const TestKeep = {
    path: '/test',
    name: 'Test',
    component: App,
    children: [{
            path: '/',
            meta: { title: i18n.t('考试详情') },
            component: () =>
                import ('@/views/train/test/detail.vue')
        },
        {
            name: 'exam',
            path: '/exam',
            meta: { title: i18n.t('考试') },
            component: () =>
                import ('@/views/train/test/exam/index.vue')
        }

    ]
}



export const detailKeep = {
    path: '/detail',
    name: 'detail',
    component: () =>
        import ('@/views/train/study/detailindex.vue'),
    meta: {
        title: i18n.t('商品详情')
    }
}
export const videoDetailKeep = {
        path: '/videoDetail',
        name: 'videoDetail',
        meta: { title: i18n.t('视频介绍')},
        component: () =>
            import ('@/views/train/study/detail/videodetail.vue'),
    }


    export const incentiveKeep = {
        path: '/incentive',
        name: 'Incentive',
        meta: { title: i18n.t('中心-激励明细')},
        component: () =>
    import ('@/views/Incentive/index.vue'),
        children: [{
            path: '/incentive/incentiveDetail',
            name: 'IncentiveDetail',
            meta: { title: i18n.t('中心-激励明细') },
            component: () =>
                import ('@/views/Incentive/IncentiveDetails/index.vue')
        },
        {
            path: '/incentive/salesman',
            name: 'Salesman',
            meta: { title: i18n.t('业务员-激励类型') },
            component: () =>
                import ('@/views/Incentive/salesman/index.vue')
        },
        {
            path: '/incentive/salesmanIncentive',
            name: 'SalesmanIncentive',
            meta: { title: i18n.t('业务员-激励来源') },
            component: () =>
                import ('@/views/Incentive/salesmanIncentive/index.vue')
        },
        ]
    }

export const PointsMall = {
    path: '/pointsMall',
    name: 'pointsMall',
    meta: { title: i18n.t('积分商城') },
    component: () =>
    import ('@/views/pointsMall/index.vue'),
    children: [{
            path: 'home',
            meta: { title: i18n.t('积分商城') },
            component: () =>
                import ('@/views/pointsMall/home.vue')
        },
        {
            path: 'create',
            meta: { title: i18n.t('创建积分订单') },
            component: () =>
                import ('@/views/pointsMall/create/index.vue')
        },
        {
            path: '/pointsMall/detail',
            meta: { title: i18n.t('积分商品详情') },
            component: () =>
                import ('@/views/pointsMall/detail/index.vue')
        },
        {
            path: '/pointsMall/orderDetail',
            meta: { title: i18n.t('积分订单详情') },
            component: () =>
                import ('@/views/pointsMall/orderDetail/index.vue')
        },
        {
            path: '/pointsMall/orderList',
            meta: { title: i18n.t('积分订单') },
            component: () =>
                import ('@/views/pointsMall/orderList/index.vue')
        },
        {
            path: '/pointsMall/pointsList',
            meta: { title: i18n.t('积分明细') },
            component: () =>
                import ('@/views/pointsMall/pointsList/index.vue')
        },
        {
            path: '/pointsMall/spend',
            meta: { title: i18n.t('花积分') },
            component: () =>
                import ('@/views/pointsMall/spend/index.vue')
        },
        {
            path: '/pointsMall/earn',
            meta: { title: i18n.t('赚积分') },
            component: () =>
                import ('@/views/pointsMall/earn/index.vue')
        }

    ]
}

// 公共页面
export const commonRouters = [
    {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        meta: { title:  i18n.t('隐私政策') },
        component: () =>
                import ('@/views/commonView/privacyPolicy/index.vue')
    },
]
 export const courseDetail=[
    {
    path: '/class/courseDetail',
    name: 'courseDetail',
    meta: { title:  i18n.t('课件详情') },
    component: () =>
    import ('@/views/train/study/courseDetail.vue'),
},
 ]   
    // 所有上面定义的路由都要写在下面的routers里
export const routers = [
      pageError, trainKeep,packageKeep, packageDetailKeep,questionKeep, TestKeep, detailKeep, videoDetailKeep,incentiveKeep, PointsMall, ...commonRouters,...courseDetail
];


// WEBPACK FOOTER //
// src/router/router.js